import { MdErrorOutline } from "react-icons/md";
import { SOCKET_OBJ_TOAST } from "../helper/const";

const ERR_OPTIONS = {
  401: {
    content: (
      <div
        className="flex flex-col justify-center items-center gap-2"
        style={{ color: SOCKET_OBJ_TOAST.error.color }}
      >
        <MdErrorOutline fontSize={58} />
        لطفا مجددا وارد حساب خود شوید
        <div className="flex flex-row gap-2">
          <a
            href="https://account.dana-institute.ir/userPanel"
            target="_blank"
            rel="noreferrer"
            className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-primary-700 bg-primary-600 text-white rounded-md !font-extralight !font-dana-normal"
          >
            ورود به حساب
          </a>
          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
            className="text-lg mt-5 p-2 px-3 duration-300 shadow-xl hover:bg-secondary-400 bg-secondary-500 text-white rounded-md !font-extralight !font-dana-normal"
          >
            تلاش مجدد
          </button>
        </div>
      </div>
    ),
  },
};
export default function ErrCm({ code }) {
  return (
    <div className="mt-5 m-auto shadow-xl justify-center !font-dana-bold w-max my-10 flex flex-col rounded-xl items-center bg-white p-32 font-kalameh text-3xl max-[800px]:p-4 max-[800px]:w-full max-[600px]:text-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      {ERR_OPTIONS[code].content}
    </div>
  );
}
